import { Component, effect, inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseChartDirective } from 'ng2-charts';
import { ChartService } from '../services/chart.service';

@Component({
  selector: 'app-vertical-bars-modal',
  templateUrl: './vertical-bars-modal.component.html',
  styleUrls: ['./vertical-bars-modal.component.scss'],
  providers: [ChartService],
  standalone: false,
})
export class VerticalBarsModalComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  public readonly dialogRef = inject(MatDialogRef<VerticalBarsModalComponent>);

  public readonly data = inject(MAT_DIALOG_DATA);

  // #region     BEGIN ChartService
  public readonly chartService$ = inject(ChartService);

  public get data$() {
    return this.chartService$.data$;
  }

  public readonly updateChartEffect$ = effect(() => {
    this.chartService$.barChartData$();
    this.chart?.update();
  });
  // #endregion  END ChartService

  ngOnInit(): void {
    this.data$.set(this.data);
  }
}
